import React from 'react';
import '../../App.scss';
import { IntlProvider, FormattedNumber } from 'react-intl';

export default function MoneyTitle(props) {

    const totalValue100s = (((props.fees || 0)) * 1 + props.amount * 1);
    const parts = props.strikethrough ? (parts => (
        <>
            <span style={{ textDecoration: 'line-through' }}>{parts}</span>
        </>
    )) : '';

    return (<IntlProvider locale='en'>
        <FormattedNumber
            value={(totalValue100s / 100) || 0}
            style="currency"
            currency={props.currency || 'EUR'}
            minimumFractionDigits={props.digits || (props.fees ? 2 : 0)}
            maximumFractionDigits={props.digits || (props.fees ? 2 : 0)} >
            {parts}
        </FormattedNumber>
    </IntlProvider>);
}
